/** @jsx jsx */
/**
 * Fresh Pets Lazy Image Placeholder
 *
 */

import { jsx } from 'theme-ui'
import LazyPlaceholderSVG from '../../assets/svg/fresh-pets-lazy-placeholder.svg'

const LazyPlaceholder = () => <LazyPlaceholderSVG sx={{ borderRadius: 2 }} />

export default LazyPlaceholder
